import { createSlice } from '@reduxjs/toolkit'
import { createUserRolesApi, getUserPagePermissionsApi } from './api'
import { notification } from '../../../components/Notifications'
import { interpretRoleAssignment } from '../../../helpers/roleHelpers'

export interface RoleSliceType {
  loading: boolean
  actionLoading: boolean
  pagePermissionError: boolean
  roleError: boolean
  roles: any
  pagePermissions: string[] | null
}

export const initialState: RoleSliceType = {
  loading: false,
  actionLoading: false,
  roles: null,
  roleError: false,
  pagePermissionError: false,
  pagePermissions: null
}

const RoleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Page Permissions
      .addCase(getUserPagePermissionsApi.pending, (state, action) => {
        state.loading = true
        state.pagePermissionError = false
      })
      .addCase(getUserPagePermissionsApi.fulfilled, (state, action) => {
        state.loading = false
        state.pagePermissionError = false
        state.pagePermissions = action.payload
      })
      .addCase(getUserPagePermissionsApi.rejected, (state, action) => {
        state.loading = false
        state.pagePermissionError = true
      })

      // Create User Role
      .addCase(createUserRolesApi.pending, (state, action) => {
        state.actionLoading = true
      })
      .addCase(createUserRolesApi.fulfilled, (state, action) => {
        state.actionLoading = false
        const { alreadyExists, message } = interpretRoleAssignment(action.payload)
        if (alreadyExists) {
          // BE 200 idempotent no-op — the assignment already existed, so show an
          // informational notice rather than a "created" success. Persist so it
          // stays until dismissed instead of auto-hiding before it is read.
          notification(message ?? 'User already has this role', { variant: 'info', persist: true })
        } else {
          notification(`${action.payload?.user?.name} added successfully ${action.payload?.section?.abbreviation}`, { variant: 'success', subTitle: action.payload?.user?.name, persist: true })
        }
      })
      .addCase(createUserRolesApi.rejected, (state, action) => {
        state.actionLoading = false
      })
  }
})

export default RoleSlice.reducer
